import * as React from 'react';
import { IClientTitleData } from 'types/clientPortal/IClientTitleData';
import { Grid, BoldSmallBodyText, BodyText, Card } from 'ui-toolkit';

export const TitleSummaryCard: React.FC<IClientTitleData> = (title) => {
  return (
    <Card title={'Title Summary'}>
      <Grid>
        <Grid columnCount={4}>
          <BoldSmallBodyText>Open Mortgages</BoldSmallBodyText>
          <BoldSmallBodyText>Bankruptcies</BoldSmallBodyText>
          <BoldSmallBodyText>Judgements</BoldSmallBodyText>
          <BoldSmallBodyText>Other Liens</BoldSmallBodyText>
          <BodyText>{title.numOfOpenMortgages || '-'}</BodyText>
          <BodyText>{title.numOfBankruptcies || '-'}</BodyText>
          <BodyText>{title.numOfJudgements || '-'}</BodyText>
          <BodyText>{title.numOfOtherLiens || '-'}</BodyText>
        </Grid>
        <BoldSmallBodyText>Assessor's Parcel number / TaxID</BoldSmallBodyText>
        <BodyText>{title.apn || '-'}</BodyText>
        <BoldSmallBodyText>Currently Vested in</BoldSmallBodyText>
        <BodyText>{title.vestingInfo || '-'}</BodyText>

        <BoldSmallBodyText>Legal Description</BoldSmallBodyText>
        <BodyText>{title.legalDescription || '-'}</BodyText>
      </Grid>
    </Card>
  );
};
